import {
    VIDEO_PAGE_RECEIVE,
    VIDEO_PAGE_ERROR,
    VIDEO_CURRENT_UPDATE,
    TAG_LIST_UPDATE,
    TAG_ACTIVE_UPDATE,
    VIDEO_ACTIVE_UPDATE
} from './VideoPage.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    videoList: [],
    currentVideo: null,
    tagList: [],
    activeTagList: [],
    activeVideoList: []
}
export const VideoReducer = (state = defaultState, action) => {
    switch (action.type) {
        case VIDEO_PAGE_RECEIVE:
            return {
                ...state,
                videoList: action.payload
            }
        case VIDEO_CURRENT_UPDATE:
            return {
                ...state,
                currentVideo: action.payload
            }
        case VIDEO_ACTIVE_UPDATE:
            return {
                ...state,
                activeVideoList: action.payload
            }
        case TAG_LIST_UPDATE:
            return {
                ...state,
                tagList: action.payload
            }
        case TAG_ACTIVE_UPDATE:
            return {
                ...state,
                activeTagList: action.payload
            }
        case VIDEO_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}